export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"

//Forget password resend code
export const FORGET_PASSWORD_RESEND_CODE = "FORGET_PASSWORD_RESEND_CODE"
export const FORGET_PASSWORD_RESEND_CODE_SUCCESS = "FORGET_PASSWORD_RESEND_CODE_SUCCESS"
export const FORGET_PASSWORD_RESEND_CODE_ERROR = "FORGET_PASSWORD_RESEND_CODE_ERROR"